export default 'Comparateur énergie B2B multi-fournisseurs : SIRET, factures importées, comparatif sous 24h. Courtier indépendant des fournisseurs d’énergie.';
